import { map } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import {
  DVFormGroup,
  DVFormControl,
  DVFormArray
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SnotifyService } from 'ng-snotify';
import _ from 'lodash';
import moment from 'moment';
import { PackagesService } from '../packages.service';

@Component({
  selector: 'app-add-package',
  templateUrl: './add-package.component.html',
  styleUrls: ['./add-package.component.css']
})
export class AddPackageComponent implements OnInit {
  packageForm: DVFormGroup;
  isAddState = true;
  excludedItems: Array<String> = [];
  constructor(
    public route: ActivatedRoute,
    private packageApi: PackagesService,
    private notifier: SnotifyService,
    private router: Router
  ) {
    this.packageForm = new DVFormGroup({
      id: new DVFormControl(null),
      name: new DVFormControl(null, {
        'name is required': Validators.required
      }),
      tagline: new DVFormControl(null),
      // discount: new DVFormControl(null),
      videoUrl: new DVFormControl('', {
        // tslint:disable-next-line: max-line-length
        'This link is not valid': Validators.pattern('(https?://)?(www\\.)?(yotu\\.be/|youtube\\.com/)?((.+/)?(watch(\\?v=|.+&v=))?(v=)?)([\\w_-]{11})(&.+)?')
      }),
      description: new DVFormControl(null),
      // highlights: new DVFormControl(null),
      included: new DVFormControl([], {
        'Included is required': Validators.required
      }),
      excluded: new DVFormControl(null, {
        'Excluded is required': Validators.required
      }),
      // facts: new DVFormControl([]),
      duration: new DVFormControl(0, {
        'Duration is required': Validators.required,
        'Duration cannot be less than 1 day': Validators.min(1),
        'Duration cannot be more than 10 days': Validators.max(20)
      }),
      metaKeywords: new DVFormControl(null),
      metaDescription: new DVFormControl(null),
      metaTitle: new DVFormControl(null),
      // packageTypes: new DVFormControl(null),

      // startIndex: new DVFormControl(null),
      // startDate: new DVFormControl(null, {
      //   'Start Date is required': Validators.required
      // }),
      // endDate: new DVFormControl(null, {
      //   'End Date is required': Validators.required
      // }),
      PackageCancellationPolicies: new DVFormArray(
        [],
        [
          {
            name: 'id',
            type: 'CONTROL',
            default: null,
          },
          {
            name: 'days',
            type: 'CONTROL',
            default: null,
            validators: {
              'Number of days is required': Validators.required
            }
          },
          {
            name: 'percentage',
            type: 'CONTROL',
            default: null,
            validators: {
              'Percentage is required': Validators.required
            }
          }
        ],
        0,
        {
          'Cancellation Policies is required': Validators.required
        }
      ),
      Price: new DVFormArray(
        [],
        [
          {
            name: 'id',
            type: 'CONTROL',
            default: null
          },
          {
            name: 'from',
            type: 'CONTROL',
            default: 0,
            validators: {
              'Number of travelers is required': Validators.required
            }
          },
          {
            name: 'to',
            type: 'CONTROL',
            default: 1,
          },
          {
            name: 'amount',
            type: 'CONTROL',
            default: 0,
            validators: {
              'Amount is required': Validators.required
            }
          }
        ],
        0,
        {
          'Prices are required': Validators.required
        }
      ),
      // Location: new DVFormControl({}, {
      //   'Package pickup location is required': Validators.required
      // }),
      PackageDays: new DVFormArray([]),
      PackagePictures: new DVFormControl([], {
        'Slider Images are required': Validators.required,
        // 'You must upload at least two images': Validators.minLength(2)
      }),
      active: new DVFormControl()
    });
  }

  ngOnInit() {
    this.route.url.subscribe((url) => {
      if (
        url.toString().includes('edit') &&
        this.route.snapshot.params.id
      ) {
        this.isAddState = false;
        this.initiateEditMode();
      } else {
        this.isAddState = true;
      }
    });
  }

  formSubmit(active?: boolean) {   
    if (this.packageForm.valid) {
      const formResult = this.packageForm.getCleanValue();
      // this.excludedItems = null;
      if (formResult.excluded) {
        for (let exc of formResult.excluded) {
          this.excludedItems.push( exc );
        }
        formResult.excluded =  this.excludedItems.toString();
      } else {
        formResult.excluded = '';
      }
      // formResult.tags = formResult.tags.map(tag => tag.id);
      // formResult.PackageTypes = formResult.packageTypes.map(type => type.id);
      console.log('ssssssssssssssssssssss', formResult);
      formResult.PackageDays = formResult.PackageDays.map((day, index) => (
        {
          id: day.id,
          order: index + 1,
          title: day.title,
          description: day.description,
          settings: {
            meals: day.meals,
            overnight: day.overnight
          },
          // Activities: day.Activities.map((activity, ind) => ({
          //   ...activity
          //   , order: ind + 1
          // }))
        }));
      
      formResult.tagline = formResult.tagline ? formResult.tagline : null;
      formResult.videoUrl = formResult.videoUrl ? formResult.videoUrl : null;
      formResult.metaKeywords = formResult.metaKeywords ? formResult.metaKeywords : null;
      formResult.metaDescription = formResult.metaDescription ? formResult.metaDescription : null;
      formResult.metaTitle = formResult.metaTitle ? formResult.metaTitle : null;

      if (this.isAddState) {
        this.performAddOperation(formResult, active);
      } else {
        this.performEditOperation(formResult, formResult.id);
      }
    } else {
      this.packageForm.forceShowErrors();
    }
  }


  private initiateEditMode() {
    const included = [];
    const excluded = [];
    const packageId = this.route.snapshot.params.id;
    this.packageApi.getSinglePackageById(packageId).subscribe(response => {
      const packageBody = response.data.experience;
      // packageBody.startDate = moment(packageBody.startDate).format('YYYY-MM-DD');
      // packageBody.endDate = moment(packageBody.endDate).format('YYYY-MM-DD');

      packageBody.included.map(a => {
        included.push(JSON.parse(a));
      });
      // packageBody.excluded.map(a => {
      //   excluded.push(JSON.parse(a));
      // });
      packageBody.PackageCancellationPolicies = packageBody.ExperienceCancellationPolicies;
      packageBody.PackagePictures = packageBody.ExperiencePictures;
      packageBody.included = included;
      packageBody.excluded = packageBody.excluded ? packageBody.excluded.split(',') : '';
      packageBody.PackageDays = packageBody.ExperienceDays.map((day, index) => ({
        id: day.id,
        order: index + 1,
        title: day.title,
        description: day.description,
        meals: day.settings.meals,
        overnight: day.settings.overnight,
        // Activities: day.Activities
      }));
      this.packageForm.patchValue(packageBody);
    });
  }

  private performAddOperation(packageFormBody, active) {
    packageFormBody = {
      active,
      ...packageFormBody
    };
    packageFormBody.ExperiencePictures = packageFormBody.PackagePictures;
    delete packageFormBody.PackagePictures;

    packageFormBody.ExperienceDays = packageFormBody.PackageDays;
    delete packageFormBody.PackageDays;

    packageFormBody.ExperienceCancellationPolicies = packageFormBody.PackageCancellationPolicies;
    delete packageFormBody.PackageCancellationPolicies;
    packageFormBody.PackageDetails = {};
    this.packageApi.addPackage(packageFormBody).subscribe(response => {
      this.notifier.success('Package Added Successfully');
      this.router.navigate(['/packages/list']);
    }, error => {
      this.notifier.error(error.error.userMessage);
    });
  }

  private performEditOperation(packageFormBody, packageId) {
    packageFormBody.ExperiencePictures = packageFormBody.PackagePictures;
    delete packageFormBody.PackagePictures;

    packageFormBody.ExperienceDays = packageFormBody.PackageDays;
    delete packageFormBody.PackageDays;

    packageFormBody.ExperienceCancellationPolicies = packageFormBody.PackageCancellationPolicies;
    delete packageFormBody.PackageCancellationPolicies;

    delete packageFormBody.RelatedExperience;
    packageFormBody.relatedExperienceIds = [];

    this.packageApi.updatePackage(packageFormBody, packageId).subscribe(response => {
      this.notifier.success('Package Editted Successfully');
      this.router.navigate(['/packages/list']);
    }, error => {
      this.notifier.error(error.error.userMessage);
    });
  }

}
export class AttachedFileModel {
  id: string;
  name: string;
  type: string;
  /**
   *
   */
  constructor() {
    this.id = '';
    this.name = '';
    this.type = '';
  }
}
